import { render, staticRenderFns } from "./bigImg.vue?vue&type=template&id=59f22ae5&scoped=true"
import script from "./bigImg.vue?vue&type=script&lang=js"
export * from "./bigImg.vue?vue&type=script&lang=js"
import style0 from "./bigImg.vue?vue&type=style&index=0&id=59f22ae5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f22ae5",
  null
  
)

export default component.exports